import { GoogleAnalyticsEditAccounts } from '@components/layouts/Connectors/GoogleAnalyticsConnector/GoogleAnalyticsEditAccounts';
import { useLoaderData } from 'react-router-dom';
import { GoogleAnalyticsEditManual } from '@components/layouts/Connectors/GoogleAnalyticsConnector/GoogleAnalyticsEditManual';
import { ConnectorFromStore } from '@/types/Connectors';

export const GoogleAnalyticsEditConnector = () => {
  const connector = useLoaderData() as ConnectorFromStore;

  if (connector && connector.config.accounts) {
    return <GoogleAnalyticsEditAccounts />;
  } else {
    return <GoogleAnalyticsEditManual />;
  }
};
